"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PushNotificationPayload = void 0;
var runtypes_1 = require("runtypes");
var CreatedPushNotification_1 = require("./push-notifications/CreatedPushNotification");
var DeletedPushNotification_1 = require("./push-notifications/DeletedPushNotification");
exports.PushNotificationPayload = (0, runtypes_1.Union)(CreatedPushNotification_1.CreatedPushNotification, DeletedPushNotification_1.DeletedPushNotification);
//# sourceMappingURL=PushNotificationPayload.js.map